import { Colors } from '../../colors';
import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const BellLine = ({ width = 18, height = 18, fill = Colors.gray700, ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M3.9375 14.1634C3.77813 14.1634 3.64456 14.1095 3.53681 14.0018C3.42894 13.8939 3.375 13.7602 3.375 13.6007C3.375 13.4413 3.42894 13.3078 3.53681 13.2C3.64456 13.0924 3.77813 13.0386 3.9375 13.0386H4.73081V7.44225C4.73081 6.43362 5.04212 5.54181 5.66475 4.76681C6.28725 3.99181 7.0865 3.49612 8.0625 3.27975V2.8125C8.0625 2.55213 8.15356 2.33075 8.33569 2.14838C8.51781 1.96613 8.73894 1.875 8.99906 1.875C9.25931 1.875 9.48075 1.96613 9.66338 2.14838C9.84613 2.33075 9.9375 2.55213 9.9375 2.8125V3.27975C10.9135 3.49612 11.7128 3.99181 12.3353 4.76681C12.9579 5.54181 13.2692 6.43362 13.2692 7.44225V13.0386H14.0625C14.2219 13.0386 14.3554 13.0924 14.4632 13.2002C14.5711 13.3081 14.625 13.4418 14.625 13.6013C14.625 13.7606 14.5711 13.8942 14.4632 14.0019C14.3554 14.1096 14.2219 14.1634 14.0625 14.1634H3.9375ZM8.99869 16.2692C8.62556 16.2692 8.30656 16.1364 8.04169 15.8709C7.77669 15.6054 7.64419 15.2863 7.64419 14.9134H10.3558C10.3558 15.2875 10.2229 15.607 9.95719 15.8719C9.69144 16.1368 9.37194 16.2692 8.99869 16.2692ZM5.85581 13.0386H12.1442V7.44225C12.1442 6.574 11.8373 5.83294 11.2234 5.21906C10.6094 4.60506 9.86825 4.29806 9 4.29806C8.13175 4.29806 7.39063 4.60506 6.77663 5.21906C6.16275 5.83294 5.85581 6.574 5.85581 7.44225V13.0386Z"
      />
    </Svg>
  );
};

export default BellLine;
